import { render, staticRenderFns } from "./AnnouncementsPage.vue?vue&type=template&id=c60649c2&scoped=true"
import script from "./AnnouncementsPage.vue?vue&type=script&lang=js"
export * from "./AnnouncementsPage.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementsPage.vue?vue&type=style&index=0&id=c60649c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60649c2",
  null
  
)

export default component.exports